import React from 'react'
import PropTypes from 'prop-types'
import createReactClass from 'create-react-class'

const breakpoint = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1200,
}

const defaultGutter = 20
const fractions = {
  1: '100%',
}

export const Grid = createReactClass({
  displayName: 'Col',
  propTypes: {
    basis: PropTypes.oneOfType([
      PropTypes.number, // allow pixels
      PropTypes.string, // allow percentage
    ]),
    children: PropTypes.node,
    gutter: PropTypes.number,
    lg: PropTypes.string, // width as a percentage or fraction
    md: PropTypes.string, // width as a percentage or fraction
    sm: PropTypes.string, // width as a percentage or fraction
    style: PropTypes.object,
    xs: PropTypes.string, // width as a percentage or fraction
    /* eslint-enable */
  },
  getInitialState: function () {
    return {
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    }
  },
  componentDidMount: function () {
    if (typeof window !== 'undefined')
      window.addEventListener('resize', this.handleResize)
  },
  componentWillUnmount: function () {
    if (typeof window !== 'undefined')
      window.removeEventListener('resize', this.handleResize)
  },
  handleResize: function () {
    this.setState({
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    })
  },
  render() {
    let { basis, gutter = defaultGutter, xs, sm, md, lg } = this.props
    let { windowWidth } = this.state

    let columnStyle = {
      minHeight: 1,
      paddingLeft: gutter / 2,
      paddingRight: gutter / 2,
    }

    // if no width control is provided fill available space
    if (!basis && !xs && !sm && !md && !lg) {
      columnStyle.flex = '1 1 auto'
      columnStyle.msFlex = '1 1 auto'
      columnStyle.WebkitFlex = '1 1 auto'
    }

    // set widths / flex-basis
    if (basis) {
      columnStyle.flex = '1 0 ' + basis
      columnStyle.msFlex = '1 0 ' + basis
      columnStyle.WebkitFlex = '1 0 ' + basis
    } else if (windowWidth < breakpoint.xs) {
      columnStyle.width = xs
    } else if (windowWidth < breakpoint.sm) {
      columnStyle.width = sm || xs
    } else if (windowWidth < breakpoint.md) {
      columnStyle.width = md || sm || xs
    } else {
      columnStyle.width = lg || md || sm || xs
    }

    if (!columnStyle.width) {
      columnStyle.width = '100%'
    }

    if (columnStyle.width in fractions) {
      columnStyle.width = fractions[columnStyle.width]
    }

    let props = this.props

    return (
      <div style={Object.assign(columnStyle, this.props.style)} {...props} />
    )
  },
})

export default Grid
